/**
 * acoesAdapter.js — Sprint 4
 *
 * Normaliza ações corretivas vindas do backend em qualquer um dos 3 shapes
 * históricos para um shape único usado por NCResultAnalysisSection,
 * ReportV2 e ReportPrintable.
 *
 * Shapes de entrada suportados:
 *   1. Registro v4    : {id, descricao, responsavel_funcao, prazo, prioridade}
 *   2. 5W2H           : {what, who, when, where, why, how, how_much}
 *   3. Legacy pré-v4  : {acao, responsavel, prazo_dias}
 *
 * Shape de saída único:
 *   {descricao, responsavel, prazo, prioridade, status}
 *
 * Campos ausentes em uma das origens caem em string vazia (nunca undefined),
 * pra não quebrar render condicional de telas que usam || fallback.
 */

export function normalizarAcaoCorretiva(acao) {
  if (!acao || typeof acao !== 'object') {
    return { descricao: '', responsavel: '', prazo: '', prioridade: '', status: '' };
  }

  // Descrição: registro v4 (descricao) > 5W2H (what) > legacy (acao)
  const descricao = acao.descricao || acao.what || acao.acao || '';

  // Responsável: registro v4 (responsavel_funcao) > 5W2H (who) > legacy (responsavel)
  const responsavel = acao.responsavel_funcao || acao.who || acao.responsavel || '';

  // Prazo: registro v4 (prazo string tipo "24h" / "30 dias") > 5W2H (when) > legacy (prazo_dias num)
  let prazo = acao.prazo || acao.when || '';
  if (!prazo && typeof acao.prazo_dias === 'number') {
    prazo = `${acao.prazo_dias} dias`;
  }

  // Prioridade: só registro v4 tem
  const prioridade = acao.prioridade || '';

  // Status: campo opcional em qualquer shape
  const status = acao.status || '';

  return { descricao, responsavel, prazo, prioridade, status };
}

export default normalizarAcaoCorretiva;
